module.exports = __webpack_public_path__ + "static/img/齿直角方式变位交错轴斜齿齿轮的计算.cdd23837.jpg";